module.exports = __webpack_public_path__ + "static/media/loxone-image-section-five.236e98b3.png";